import { Msg } from "@shared/components";

const informationItems = [
  {
    title: "editor-exam-detail.modals.firstModal.no-cheat.title",
    text: "editor-exam-detail.modals.firstModal.no-cheat.text",
  },
  {
    title: "editor-exam-detail.modals.firstModal.no-share.title",
    text: "editor-exam-detail.modals.firstModal.no-share.text",
  },
  {
    title: "editor-exam-detail.modals.firstModal.no-personal-info.title",
    text: "editor-exam-detail.modals.firstModal.no-personal-info.text",
  },
];

export const Caution = () => {
  return (
    <div className="code-editor-exam-detail-caution">
      {informationItems.map((item, index) => {
        return (
          <div key={item.title}>
            <div className={`icon icon-${index}`}></div>
            <div className="title-container">
              <Msg id={item.title} className="title" />
            </div>
            <div>
              <Msg id={item.text} className="text" />
            </div>
          </div>
        );
      })}
    </div>
  );
};
